// src/utils/showToast.ts

import React from "react";
import toast from "react-hot-toast";
import { ToastModal, ToastType } from "../components/ToastModal";

interface ShowToastOptions {
	title: string;
	subtitle?: string;
	detail?: string;
	buttonText?: string;
}

function show(type: ToastType, opts: ShowToastOptions) {
	toast.custom(
		(t) =>
			React.createElement(ToastModal, {
				toastId: t.id,
				type,
				title: opts.title,
				subtitle: opts.subtitle,
				detail: opts.detail,
				buttonText: opts.buttonText,
			}),
		{ duration: Infinity, id: `modal-${Date.now()}` },
	);
}

export const showSuccess = (title: string, subtitle?: string, detail?: string) =>
	show("success", { title, subtitle, detail });

export const showError = (title: string, subtitle?: string, detail?: string) =>
	show("error", { title, subtitle, detail });

export const showWarning = (title: string, subtitle?: string, detail?: string) =>
	show("warning", { title, subtitle, detail });

export const showInfo = (title: string, subtitle?: string, detail?: string) =>
	show("info", { title, subtitle, detail });
